module.exports = __webpack_public_path__ + "static/media/fifth_north_church6.16dd8704.jpg";